// components/DraggableModal.js
import React, { useEffect } from 'react'
import { first } from 'lodash'
import ModalMainWrapper from './ModalMainWrapper'
import ModalContent from './ModalContent'
import ModalHeader from './ModalHeader'

const SampleReturnModal = ({ isOpen, onClose, exampleRows, getValues }) => {
    const [object, setObject] = React.useState({})

    useEffect(() => {
        const values = getValues()
        const exampleRow = first(exampleRows)

        if (!exampleRows || !exampleRow) return null

        const retName = exampleRow[values['retname']] || values['retname']
        const retAddress =
            exampleRow[values['retaddress']] || values['retaddress']
        const retCityZip = exampleRow[values['retarea']] || values['retarea']
        setObject({
            retCityZip,
            retAddress,
            retName,
        })

        return () => {
            setObject({})
        }
    }, [isOpen])

    if (!exampleRows) return null

    return (
        <ModalMainWrapper show={isOpen}>
            <div className="inline-block w-full rounded-md max-w-md pb-4 pt-2 px-2 border overflow-hidden text-left bg-gray-100 align-middle transition-all transform">
                <ModalContent>
                    <ModalHeader
                        onClose={onClose}
                        title="Sample Return Address"
                    />
                    <div className="bg-white relative h-48 mt-4 mx-2 ">
                        <div className="absolute top-4 left-4">
                            <p>{object?.retName}</p>
                            <p>{object?.retAddress}</p>
                            <p>{object?.retCityZip}</p>
                        </div>

                        <div className="absolute bottom-4 right-4 text-gray-400">
                            <p>Mailing Name</p>
                            <p>Mailing Address</p>
                            <p>Mailing City, State, Zip</p>
                        </div>
                    </div>
                </ModalContent>
            </div>
        </ModalMainWrapper>
    )
}

export default SampleReturnModal
